import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const SourceMaterial = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0669 4.125L14.5605 5.49358L13.1919 6.00001L14.5605 6.50643L15.0669 7.87501L15.5733 6.50643L16.9419 6.00001L15.5733 5.49358L15.0669 4.125ZM10.8794 5.43755L9.93408 7.99221L7.37939 8.93752L9.93408 9.88283L10.8794 12.4375L11.8247 9.88283L14.3794 8.93752L11.8247 7.99221L10.8794 5.43755ZM13.5486 12.1067L14.0044 10.875L14.4601 12.1067L15.6919 12.5625L14.4601 13.0183L14.0044 14.25L13.5486 13.0183L12.3169 12.5625L13.5486 12.1067Z"
          fill={color}
        />
        <path
          d="M20.3398 7.57197C19.6022 4.62161 16.7974 1.49344 11.7763 2.1916C6.7552 2.88975 4.42289 6.46076 4.42289 9.73857C4.42435 10.5638 4.59413 11.5498 4.82983 12.3401L3.375 15.8949H5.91218L6.72365 18.939C6.92735 19.6995 7.6766 20.1336 8.42834 19.9307L11.2945 19.1581L11.9499 21.6178H19.7289L18.3145 16.3089L18.5425 16.1053C20.3512 14.4878 21.0774 10.5223 20.3398 7.57197Z"
          stroke={color}
          strokeWidth="0.933477"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
